/**
 * Replaces matching slip(s) in a pick-slip list while keeping list order stable.
 *
 * The "Review & edit your picks" screen derives game order from the first
 * appearance of each gameId in the slips array. A naive filter-then-append
 * moves an edited game's slip to the end, making its game block jump to the
 * bottom. This helper inserts the replacement slip at the position of the
 * first removed slip instead, so editing a bet never reorders the games.
 *
 * If nothing matches `shouldRemove`, the new slip is appended (a genuinely new
 * pick for a game not yet in the list should appear at the bottom).
 */

export function replaceSlipPreservingOrder<T>(
  slips: T[],
  shouldRemove: (slip: T) => boolean,
  newSlip: T
): T[] {
  const insertIndex = slips.findIndex(shouldRemove);
  const without = slips.filter((slip) => !shouldRemove(slip));
  if (insertIndex === -1) {
    return [...without, newSlip];
  }
  return [...without.slice(0, insertIndex), newSlip, ...without.slice(insertIndex)];
}
